import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import * as colors from "../settings/colors";

export const linkStyles = css`
  color: ${props => props.color || colors.TEXT};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${colors.BLUE};
  }
`;

const StyledLink = styled(({ color, ...otherProps }) => (
  <Link {...otherProps} />
))([linkStyles]);

export const A = styled.a([linkStyles]);

export default StyledLink;



// WEBPACK FOOTER //
// ./src/components/Link.js